var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3852 0.973203C2.11102 0.344268 3.03959 -0.00133594 4 3.88106e-06C6.20919 3.88106e-06 7.99999 1.7908 7.99999 4C7.99999 4.8544 7.73199 5.6464 7.27599 6.296L5.99999 4H7.19999C7.20004 3.37265 7.01569 2.75912 6.66986 2.2357C6.32403 1.71229 5.83197 1.30207 5.25487 1.05605C4.67777 0.810039 4.04108 0.739084 3.42398 0.85201C2.80688 0.964937 2.23658 1.25676 1.784 1.6912L1.3852 0.973203ZM6.61479 7.0268C5.88897 7.65573 4.9604 8.00134 4 8C1.7908 8 0 6.2092 0 4C0 3.1456 0.268 2.3536 0.723999 1.704L2 4H0.799999C0.799948 4.62735 0.9843 5.24088 1.33013 5.7643C1.67597 6.28771 2.16803 6.69793 2.74513 6.94395C3.32223 7.18996 3.95891 7.26092 4.57601 7.14799C5.19312 7.03506 5.76341 6.74324 6.21599 6.3088L6.61479 7.0268Z",
    fill: "#3F4254"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientChange);
export default __webpack_public_path__ + "static/media/gradientChange.87c30623401b6af8a0502bfaf04dbdda.svg";
export { ForwardRef as ReactComponent };